import { Nullish } from 'types'

export const FEATURE_NAME = 'games'

export interface SchoolStandings {
  won: number
  lose: number
  tie: number
}

export interface GamesByStateRequest {
  stateId?: string
  districtId?: string
  sportId?: string
  isLeague?: boolean
  leagueId?: string
  date?: string
}

export interface GamesV3Request {
  stateIds?: string[]
  districtIds?: string[]
  sportIds?: string[]
  isLeague?: boolean
  leagueIds?: string[]
  date?: string | null
  countPerSport?: number
}

export const DEFAULT_GAMES_COUNT_PER_SPORT = 8

export interface GamesBySchoolRequest {
  stateIds?: string[]
  districtIds?: string[]
  schoolIds?: string[]
  date?: string | null
  countPerSport?: number
}

export interface Team {
  id: string // team id
  name: string
  shortName: string
  imgUrl: string
  isHome: boolean
  isWon: boolean
  stateId: string
  districtId: string
  schoolId: string
  sportId: string
  score: number
  standings: Nullish<SchoolStandings>
}

export interface Game {
  id: string // game id
  name: string
  eventDate: string
  startTime: string | null
  endTime: string | null
  year: string
  season: string
  isNoHomeTeam: boolean
  isTBD: boolean
  sport: {
    id: string
    name: string
  }
  teams: Team[]
}

export interface GamesResponse {
  games: Game[]
}

export interface GamesGroupBySport {
  sportId: string
  sportName: string
  games: Game[]
}

export type GamesV2Response = GamesGroupBySport[]

export function sortTeams(teams: Team[]) {
  return [...teams].sort((a, b) => Number(a.isHome) - Number(b.isHome))
}
